import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FaqContainerComponent} from './components/faq-container/faq-container.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';


@NgModule({
            declarations: [FaqContainerComponent],
            exports:      [FaqContainerComponent],
            imports:      [
              CommonModule,
              MatButtonModule,
              MatIconModule
            ]
          })
export class FaqModule {
}
